import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import logo from "../../images/lo.svg";
import logo1 from "../../images/comp.svg";
import logo2 from "../../images/reports.svg";

const HamburgerMenu = ({ user }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const hasPermission = (appId) => {
    return user?.user?.appPermissions?.find(p => p.app_id === appId && p.status === "Active");
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dropdown d-flex" ref={menuRef}>
      <button
        className="ml-2 mt-4 mt-lg-0 btn btn-sm btn-light-primary text-primary d-flex align-items-center"
        style={{ padding: "0 0.5rem" }}
        id="dropdownMenuButton"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="sr-only">More</span>
        <i aria-hidden="true" className="fa-light fa-ellipsis-vertical" style={{ fontSize: "1.25rem" }}></i>
      </button>

      <div
        className={`dropdown-menu dropdown-menu-right${open ? " show" : ""}`}
        aria-labelledby="dropdownMenuButton"
      >
        <div className="d-flex col-12">
          <img
            className="mr-0 mt-2 mr-2"
            src={logo1}
            width="25"
            height="25"
            alt="logo"
          />
          <a
            className="dropdown-item pl-1 col-10"
            href={process.env.REACT_APP_COMPLIANCE_POST_INTRA_APP_LINK}
          >
            Compliance Post
          </a>
        </div>

        {hasPermission(6) && (
          <div className="d-flex col-12">
            <img
              className="mr-0 mt-2 mr-2"
              src={logo}
              width="25"
              height="25"
              alt="logo1"
            />
            <a
              className="dropdown-item pl-1 col-10 "
              href={process.env.REACT_APP_LOCAL_OUTREACH_INTRA_APP_LINK}
            >
              Local Outreach
            </a>
          </div>
        )}
        <div className="d-flex col-12">
          <img
            className="mr-0 mt-2 mr-2"
            src={logo2}
            width="25"
            height="25"
            alt="logo"
          />
          <a
            className="dropdown-item pl-1 col-10"
            href={process.env.REACT_APP_REPORTS_INTRA_APP_LINK}
          >
            Reports
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(HamburgerMenu);